import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, MapPin, ChevronRight } from "lucide-react";
import { PHONE, PHONE_HREF, SERVICE_AREAS, SERVICES } from "@/data/services";
import { useSiteImages } from "@/lib/siteImages";

const Areas = () => {
  const a = SERVICES.areas;
  const { slots } = useSiteImages();
  return (
    <div data-testid="areas-page">
      <section className="relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(to right, rgba(5,5,5,0.92) 0%, rgba(5,5,5,0.55) 70%, rgba(5,5,5,0.3) 100%), url(${slots.areas || a.image})`,
          }}
        />
        <div className="relative mx-auto max-w-page px-6 lg:px-10 pt-20 pb-28">
          <nav className="text-xs tracking-widerx uppercase flex items-center gap-2 mb-12" aria-label="Breadcrumb">
            <Link to="/" className="text-muted hover:text-gold">Home</Link>
            <ChevronRight size={12} className="text-dim" />
            <span className="text-ink">Service Areas</span>
          </nav>
          <div className="max-w-3xl fade-up">
            <div className="eyebrow mb-5">{a.eyebrow}</div>
            <h1 className="font-display text-[clamp(3rem,8vw,7rem)] font-extrabold leading-[0.9] text-ink mb-6">
              {a.title}
            </h1>
            <p className="text-ink text-xl md:text-2xl font-light leading-snug max-w-2xl mb-10">
              {a.hero}
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-page px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
            <div className="lg:col-span-5">
              <div className="eyebrow mb-5">Where We Work</div>
              <h2 className="font-display text-4xl md:text-5xl text-ink leading-tight">
                Wide coverage, local response times.
              </h2>
            </div>
            <div className="lg:col-span-7 lg:pl-8">
              <p className="text-muted text-lg leading-relaxed">{a.intro}</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-line">
            {SERVICE_AREAS.map((area, i) => (
              <div
                key={area.name}
                data-testid={`area-${i}`}
                className="bg-bg hover:bg-card transition-colors p-8 group"
              >
                <MapPin size={22} className="text-gold mb-5" />
                <h3 className="font-display text-2xl text-ink mb-2 group-hover:text-gold transition-colors">
                  {area.name}
                </h3>
                <p className="text-muted">{area.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-elevated border-t border-line">
        <div className="mx-auto max-w-page px-6 lg:px-10 text-center">
          <h2 className="font-display text-4xl md:text-6xl text-ink mb-5">Not Sure if You're in Our Area?</h2>
          <p className="text-muted text-lg max-w-xl mx-auto mb-10">
            Give us a call — we travel for civil scope and renovation projects across regional Victoria.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a href={PHONE_HREF} className="btn-gold" data-testid="areas-cta-call">
              <Phone size={16} /> Call {PHONE}
            </a>
            <Link to="/contact" className="btn-ghost" data-testid="areas-cta-quote">
              Request a Quote <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Areas;
